import { useI18n } from "utils/with-i18n.utils";

import { QuestionDropdown } from "./QuestionDropDown";

type QuestionsSectionProps = {
  productName?: string | null;
};

export const QuestionsSection = ({ productName }: QuestionsSectionProps) => {
  const i18n = useI18n();

  return (
    <section className="flex flex-col items-center">
      <h2 className="my-7 text-3xl font-medium text-center lg:my-14 lg:text-6xl">
        {i18n.t(
          productName
            ? "product.questionsSection.title"
            : "catalog.questionsSection.title",
          { productName },
          { html: true },
        )}
      </h2>

      <p className="mt-2 text-center lg:hidden">
        {i18n.t("product.questions.description", {}, { html: true })}
      </p>

      <article className="mb-16 w-full max-w-4xl lg:mb-12">
        <QuestionDropdown
          question={i18n.t("product.questions.1.label")}
          answer={i18n.t("product.questions.1.content")}
        />
        <QuestionDropdown
          question={i18n.t("product.questions.2.label")}
          answer={i18n.t("product.questions.2.content")}
        />
        <QuestionDropdown
          question={i18n.t("product.questions.3.label")}
          answer={i18n.t("product.questions.3.content")}
        />
        <QuestionDropdown
          question={i18n.t("product.questions.4.label")}
          answer={i18n.t("product.questions.4.content")}
        />
        <QuestionDropdown
          question={i18n.t("product.questions.5.label")}
          answer={i18n.t("product.questions.5.content")}
        />
        <QuestionDropdown
          question={i18n.t("product.questions.6.label")}
          answer={i18n.t("product.questions.6.content")}
        />
        <QuestionDropdown
          question={i18n.t("product.questions.7.label")}
          answer={i18n.t("product.questions.7.content")}
        />
        <QuestionDropdown
          question={i18n.t("product.questions.8.label")}
          answer={i18n.t("product.questions.8.content")}
        /> 
        <QuestionDropdown
          question={i18n.t("product.questions.9.label")}
          answer={i18n.t("product.questions.9.content")}
        />
      </article>
    </section>
  );
};
